/*@flow*/
import isType from './isType';
import type { TypeT, Predicate } from './types';

type PropT = { [key: string]: TypeT<*> };
type MixinT = TypeT<*> | PropT;

function isRefinement(type: MixinT): %checks {
  return isType(type) && type.meta.kind === 'subtype';
}

function getPredicates(type: MixinT): Predicate[] {
  return isRefinement(type)
    ? [type.meta.predicate].concat(getPredicates(type.meta.type))
    : [];
}

function getUnrefinedType(type: any): TypeT<*> {
  return isRefinement(type) ? getUnrefinedType(type.meta.type) : type;
}

function decompose(type: MixinT): {|predicates: Array<Predicate>, unrefinedType: TypeT<{...}>|} {
  return {
    predicates: getPredicates(type),
    unrefinedType: getUnrefinedType(type),
  };
}

export default decompose;
